import { CheckCircleOutlined, CheckCircleTwoTone, ClockCircleOutlined, ClockCircleTwoTone, ExclamationCircleOutlined, ExclamationCircleTwoTone } from "@ant-design/icons";
import { Divider, Alert } from "antd";

const REPLY_SCOPE: any = {

    SYNC: "Sincronizada",
    MANUAL: "Manual",
    AUTOMATED: "Automática"    
}

export const getReviewStatus = (review: any) => {
    
    if (!review.reviewReplyComment) { // Caso sin respuesta: Pendiente
        return { 
            Icon: ClockCircleOutlined,
            color: 'MediumVioletRed',
            background: 'LavenderBlush',
            tooltip: 'Sin Respuesta',
            status: 'PENDING', 
            alert: <></>
        };
    }
  
    const replyScope = review.replyScope ? REPLY_SCOPE[review.replyScope] : '';
        
    let isModified = false;
    
    if (review.createdTime && review.updateTime) {
        const createdTime = new Date(review.createdTime).getTime();
        const updateTime = new Date(review.updateTime).getTime();
  
        if (!isNaN(createdTime) && !isNaN(updateTime)) {
            isModified = createdTime < updateTime;
        }
    }
    
    return (
        review.obsoleteReply ? // Caso respuesta modificada, status Obsoleta
            { Icon: ExclamationCircleOutlined, color: 'orange', background: 'ivory', tooltip: 'Respuesta Obsoleta', replyScope: replyScope, status: 'OBSOLETE', alert: <Alert showIcon style={{ marginTop: '12px' }} type='warning' message='El cliente ha modificado la reseña y la IA nos dice que la respuesta no es coherente con la puntuación. Edita la respuesta y desaparecerá esta alerta.' /> } 
            : 
            isModified ? 
                { Icon: ExclamationCircleOutlined, color: '#389e0d', background: '#F3FFFA', tooltip: 'Respondida', replyScope: replyScope, status: 'REPLIED', alert: <></> } // Caso respuesta modificada, status OK
                :
                { Icon: CheckCircleOutlined, color: '#389e0d', background: '#F3FFFA', tooltip: 'Respondida', replyScope: replyScope, status: 'REPLIED', alert: <></> } // Respondida
    );

  };